











































































































































































































































































































































































































































































































import { Vue, Component, Ref, Watch } from 'vue-property-decorator'
import SeletorDeLojasDoUsuario from '@/components/loja/SeletorDeLojasDoUsuario.vue'
import SeletorDeTipoDeCliente from '@/components/tabeladepreco/SeletorDeTipoDeCliente.vue'
import CamposDeFiltrosDeTitulos from '@/views/application/titulos/CamposDeFiltrosDeTitulos.vue'
import DialogoDePagamentoEmMassaDeTitulos from '@/views/application/titulos/DialogoDePagamentoEmMassaDeTitulos.vue'
import SeletorDeCliente from '../clientes/SeletorDeCliente.vue'
import DataTableDeCrudPaginado from '@/components/ui/DataTableDeCrudPaginado.vue'
import DatePicker from '@/components/ui/DatePicker.vue'
import { Pageable } from '@/models/Pageable'
import axios, { CancelToken, CancelTokenSource } from 'axios'
import {
	FiltroDeTitulos,
	FluxoDoTitulo,
	Page,
	SituacaoDoTitulo,
	TipoDeCliente,
	TipoDePessoa,
	Titulo,
	TotalizadoresDeTitulo,
	Usuario,
} from '@/models'
import { DeleteTituloUseCase, FindTituloUseCase, SaveTituloUseCase } from '@/usecases'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { dateToPtBrFormat } from '@/shareds/date/date-utils'
import DialogoDeEdicaoDeTitulo from './DialogoDeEdicaoDeTitulo.vue'
import CheckboxButton from '@/components/ui/CheckboxButton.vue'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import Confirmacao from '@/components/ui/Confirmacao.vue'

type AbaDeTitulo = 'Dash 1' | 'Dash 2'

const FILTRO_DE_TITULOS = 'FILTRO_DE_TITULOS'

@Component({
	components: {
		SeletorDeLojasDoUsuario,
		SeletorDeTipoDeCliente,
		CamposDeFiltrosDeTitulos,
		SeletorDeCliente,
		DataTableDeCrudPaginado,
		DatePicker,
		DialogoDeEdicaoDeTitulo,
		CheckboxButton,
		DialogoDePagamentoEmMassaDeTitulos,
		Confirmacao,
	},
})
export default class NovaTelaDeTitulos extends Vue {
	@Ref() dialogoDeFiltros!: CamposDeFiltrosDeTitulos
	@Ref() dataTablePaginado!: DataTableDeCrudPaginado
	@Ref() dialogoDeEdicao!: DialogoDeEdicaoDeTitulo
	@Ref() form!: HTMLFormElement
	@Ref() dialogoDePagamentoEmMassaDeTitulos!: DialogoDePagamentoEmMassaDeTitulos
	@Ref() confirmacaoRemocao!: Confirmacao

	deleteTituloUseCase = new DeleteTituloUseCase()
	findTituloUseCase = new FindTituloUseCase()
	saveTituloUseCase = new SaveTituloUseCase()
	cancelToken: CancelTokenSource | null = null

	usarTodosOsFiltrados = false
	quantidadeItensSelecionados = 0
	tabs: AbaDeTitulo[] = []
	titulos: Titulo[] = []
	totalizador: TotalizadoresDeTitulo | null = null
	tituloParaDeletar: Titulo | null = null
	titulosAlterados: Titulo[] = []
	titulosSelecionados: NovaTelaDeTitulos['titulosFormatados'] = []
	filtroRapidoAtivo: 'aberto' | 'vencido' | 'comPagamento' | null = null

	buscando = false
	show = false
	show2 = false
	lojaId = ''
	tipoDeCliente = ''
	tab: null | number = null
	todosForamSelecionados = false
	menuAberto = false
	indice: null | number = null
	desabilitaSelecionarTodos = false
	titulosAtualizandoIds: string[] = []

	paginacao = {
		page: 0,
		itemsPerPage: 10,
		itemsLength: 10,
	}

	filtros: FormDeFiltroDeTitulos = localStorage[FILTRO_DE_TITULOS]
		? JSON.parse(localStorage[FILTRO_DE_TITULOS]) 
		: this.obterFiltrosDeTitulosIniciais()

		headers = [
			{ text: 'Loja', value: 'loja' },
			{ text: 'Pagamento da Venda', value: 'formaDePagamento' },
			{ text: 'Série', value: 'serie'},
			{ text: 'Número', value: 'numero'},
			{ text: 'Parcela', value: 'sequencia' },
			{ text: 'Descrição', value: 'descricao' },
			{ text: 'Competência', value: 'dataDeCompetencia' },
			{ text: 'Vencimento', value: 'dataDeVencimento' },
			{ text: 'Data Pagamento', value: 'dataPagamento', sortable: false},
			{ text: 'Cliente', value: 'pessoa'},
			{ text: 'Valor', value: 'valor', width: '15%', align: 'right' },
			{ text: 'Saldo Devedor', value: 'valorAtualizado', width: '15%', sortable: false,  align: 'right' },
			{ text: 'Juros e Multa', value: 'totalEncargos', width: '15%', sortable: false,  align: 'right' },
			{ text: 'Pago em Juros', value: 'totalPagoNosJuros', width: '15%', sortable: false,  align: 'right' },
			{ text: 'Pago em Multa', value: 'totalPagoNaMulta', width: '15%', sortable: false,  align: 'right' },
			{ text: 'Pago no Titulo', value: 'totalPagoNoTitulo', width: '15%', sortable: false,  align: 'right' },
			{ text: 'Total Pago', value: 'totalPago', width: '15%', sortable: false,  align: 'right' },
		]

		get dataHojeFormatada(): string {
			const hoje = new Date()

			const ano = hoje.getFullYear()
			const mes = String(hoje.getMonth() + 1).padStart(2, '0')
			const dia = String(hoje.getDate()).padStart(2, '0')

			return `${ano}-${mes}-${dia}`
		}

		mounted() {
			this.aplicarFiltros();
		}

		aplicarFiltros() {
			this.dataTablePaginado.reiniciar(this.filtrosFormatados)
			this.buscar
		}

		@Watch('filtros', { deep: true })
		atualizarFiltroStore() {
			localStorage[FILTRO_DE_TITULOS] = JSON.stringify(this.filtros)
		}

		@Watch('filtros.loja')
		onLojaAutoSelecionada(newVal: string | null, oldVal: string | null) {
			if (oldVal === null && newVal !== null) {
				this.dataTablePaginado.reiniciar(this.filtrosFormatados)
			}
		}

		@Watch('filtros.pessoa')
		onChangePessoa() {
			if (!this.filtros.pessoa) {
				this.filtroRapidoAtivo = null
			}

			if (this.filtros.pessoa && this.filtros.clienteAdquirente) {
				this.filtros.clienteAdquirente = null
			}
		}

		@Watch('filtros.clienteAdquirente')
		async onChangeClienteAdquirente() {
			if (this.filtros.pessoa && this.filtros.clienteAdquirente){
				this.filtros.pessoa = null
			}
		}

		@Watch('filtroRapidoAtivo')
		onChangeFiltroRapido() {
			if (!this.filtroRapidoAtivo){
				this.filtros.formaDePagamento = null
				this.filtros.dataFimPeriodo = null
				this.filtros.situacaoDoTitulo = null
				this.aplicarFiltros()
			}
		}

		limparParaFiltrosRapidos(){
			this.filtros.tipoDeCliente = null
			this.filtros.dataInicioPeriodo = null
			this.filtros.dataFimPeriodo = null
			this.filtros.situacaoDoTitulo = null
			this.filtros.formaDePagamento = null
			this.filtros.numeroDocumento = null
			this.filtros.dataInicioPagamento = null
			this.filtros.dataFimPagamento = null
			this.filtros.numeroDoCheque = null
			this.filtros.clienteAdquirente = null
		}

		ativarFiltroRapido(filtro: 'aberto' | 'vencido' | 'comPagamento') {
			if (this.filtroRapidoAtivo === filtro) {
				this.filtroRapidoAtivo = null
				return
			}
			this.filtroRapidoAtivo = filtro

			if (filtro === 'vencido') {
				this.limparParaFiltrosRapidos()
				this.filtros.formaDePagamento = 'Crediário'
				this.filtros.dataFimPeriodo = this.dataHojeFormatada
				this.filtros.situacaoDoTitulo = 'Aberto'
				this.aplicarFiltros()
			}

			if(filtro === 'aberto'){
				this.limparParaFiltrosRapidos()
				this.filtros.formaDePagamento = 'Crediário'
				this.filtros.situacaoDoTitulo = 'Aberto'
				this.aplicarFiltros()
			}

			if(filtro === 'comPagamento'){
				this.limparParaFiltrosRapidos()
				this.filtros.formaDePagamento = 'Crediário'
				this.aplicarFiltros()
			}
		}

		exibeConfirmacao(indice: number) {
			this.tituloParaDeletar = this.itens[indice]
			this.confirmacaoRemocao.mostrar()
		}

		abrirFiltros() {
			this.dialogoDeFiltros.mostrar()
		}

		limparSelecao() {
			this.usarTodosOsFiltrados = false
			this.todosForamSelecionados = false
			this.quantidadeItensSelecionados = 0;
		}

		async buscarPorTodosOsTitulosNaoPagos() {
			this.desabilitaSelecionarTodos = true
			try {
				let paginaAtual = 0;
				let totalPaginas = 1;
				const titulosEmAberto: Titulo[] = [];
				while (paginaAtual < totalPaginas) {
					this.cancelToken = axios.CancelToken.source();
					const pagina = await this.buscar(
						{ ...this.paginacao, page: paginaAtual },
						this.filtrosFormatados,
						this.cancelToken.token,
					);
					totalPaginas = pagina.totalPages;
					paginaAtual++;
					const titulosFiltrados = pagina.content.filter(titulo => titulo.situacao === 'Aberto' && this.usarTodosOsFiltrados === true) as Titulo[];
					titulosEmAberto.push(...titulosFiltrados);
				}
				
				this.cancelToken = axios.CancelToken.source();
				const pageable = { page: this.paginacao.page, size: this.paginacao.itemsPerPage, sort: [] };
				const filtros = { ...this.filtrosFormatados, situacao: 'Aberto' };
				await this.buscar(pageable, filtros, this.cancelToken.token);
				
				this.titulos = titulosEmAberto;
				
			} catch (error) {
				AlertModule.setError(error);
			} finally {
				this.desabilitaSelecionarTodos = false
			}
		}

		async buscarPorTitulosNaoPagos(){
			
			this.desabilitaSelecionarTodos = true
			
			try{
				this.cancelToken = axios.CancelToken.source();
				const filtros = { ...this.filtrosFormatados, situacao: 'Aberto' };
				this.buscar(
					{ page: this.paginacao.page, size: this.paginacao.itemsPerPage },
					filtros,
					this.cancelToken.token,
				)
				
			} catch (error) {
				AlertModule.setError(error);
			} finally {
				this.desabilitaSelecionarTodos = false
			}
		}

		abrirDialogoDeCriarBaixa(indice: number) {
			this.dialogoDeEdicao.mostrarDialogo(this.titulos[indice], 'editar', 'criacao')
		}

		abrirDialogoDeEdicaoDeTitulo(indice: number) {
			this.dialogoDeEdicao.mostrarDialogo(this.titulos[indice], 'editar', 'edicao')
		}

		abrirDialogoDeCriacaoDeTitulo() {
			this.dialogoDeEdicao.mostrarDialogo('Entrada', 'criar', 'edicao')
		}

		get podeCriarBaixaDeContasAReceber(){
			return UserLoginStore.permiteRegraDeNegocio('pode-criar-baixas-de-contas-a-receber')
		}

		get podeEditarTitulos(){
			return !!this.temRecurso('alterar', 'contas-a-receber')
		}

		get podeExcluirTitulos(){
			return !!this.temRecurso('deletar', 'contas-a-receber')
		}

		get temRecurso() {
			return UserLoginStore.temAutorizacaoPorOperacaoERecurso
		}

		mostrarPagamentoEmMassa() {
			if (!this.podeBaixarMultiplas) return AlertModule.setError('Perfil não possui permissão para baixas múltiplas.')

			const existFiltrosAtivos = !!(this.filtros.pessoa && this.filtros.loja);

			if(existFiltrosAtivos){
				this.dialogoDePagamentoEmMassaDeTitulos.mostrar(this.titulos)
			}else{
				this.dialogoDePagamentoEmMassaDeTitulos.mostrar()
			}
		}

		insereTitulo(titulos: Array<Titulo>) {
			this.titulos = this.titulos.concat(titulos)
			this.dataTablePaginado.reiniciar(this.filtrosFormatados)
		}

		formatarNumero(numero) {
			const numeroFormatado = numero.toLocaleString('pt-BR', {
				style: 'currency',
				currency: 'BRL',
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			});
			return numeroFormatado;
		}

		get abasPermitidas() {
			this.tabs = ['Dash 1', 'Dash 2']
			return this.tabs
		}

		get tokenDoUsuario() {
			return UserLoginStore.token
		}

		get tipoDePessoa(): TipoDePessoa {
			return 'Cliente'
		}

		get totalPorcelasPorDocumento(): Record<string, number> {
			const totais: Record<string, number> = {}
			for (const titulo of this.titulos) {
				const chave = `${titulo.numero}-${titulo.serie ?? ''}-${titulo.loja?.id ?? ''}`
				totais[chave] = Math.max(totais[chave] || 0, titulo.sequencia)
			}
			return totais
		}

		get titulosFormatados() {
			return this.titulos.map(titulo => {
				const totalEncargos = (titulo.juros || 0) + (titulo.multa || 0);

				const maxDescriptionLength = 18; 
				let descricao = titulo.descricao || '';
				const descricaoCompleta = descricao;
				if (descricao.length > maxDescriptionLength) {
					const truncated = descricao.substring(0, maxDescriptionLength);
					const lastSpaceIndex = truncated.lastIndexOf(' ');
					if (lastSpaceIndex > 0) {
						descricao = truncated.substring(0, lastSpaceIndex) + '...';
					} else {
						descricao = truncated + '...';
					}
				}

				const somaValorPagamentoJurosExistentes = (titulo.baixaDePagamento ?? []).reduce((soma, baixa) => {
					return soma + Number(baixa?.valorJurosSobreBaixa || 0)
				}, 0);

				const somaValorPagamentoMultaExistentes = (titulo.baixaDePagamento ?? []).reduce((soma, baixa) => {
					return soma + Number(baixa?.valorDaMultaSobreBaixa || 0)
				}, 0);

				const somaValorPagamentoBaixasExistentes = (titulo.baixaDePagamento ?? []).reduce((soma, baixa) => {
					return soma + Number(baixa?.valorPagamento || 0)
				}, 0);

				const somaValorPagamentoBaixasExistentesTotaisNoTitulo = (titulo.baixaDePagamento ?? []).reduce((soma, baixa) => {
					return soma + (
						(Number(baixa?.valorPagamento || 0) +
						Number(baixa?.valorDaMultaSobreBaixa || 0) +
						Number(baixa?.valorJurosSobreBaixa || 0))
					);
				}, 0);

				const chaveDocumento = `${titulo.numero}-${titulo.serie ?? ''}-${titulo.loja?.id ?? ''}`
				const totalParcelas = this.totalPorcelasPorDocumento[chaveDocumento] || titulo.sequencia

				return {
					...titulo,
					totalParcelas,
					dataDeVencimento: dateToPtBrFormat(titulo.dataDeVencimento),
					dataDeCompetencia: dateToPtBrFormat(titulo.dataDeCompetencia),
					descricaoCompleta,
					dataPagamento: titulo.baixaPagamento ? dateToPtBrFormat(titulo.baixaPagamento) : null,
					valor: titulo.valor?.toLocaleString('pt-br', {
						style: 'currency',
						currency: 'BRL',
					}) || '',
					pessoa: titulo.pessoa?.razaoSocialOuNome || '',
					loja: titulo.loja?.nomeFantasia || '',
					formaDePagamento: titulo.formaDePagamento
						? this.displayPagamento(titulo.formaDePagamento)
						: '',
					valorAtualizado: titulo.valorAtualizado?.toLocaleString('pt-br', {
						style: 'currency',
						currency: 'BRL',
					}) || '',
					juros: titulo.juros?.toLocaleString('pt-br', {
						style: 'currency',
						currency: 'BRL',
					}) || '',
					multa: titulo.multa?.toLocaleString('pt-br', {
						style: 'currency',
						currency: 'BRL',
					}) || '',
					totalEncargos: totalEncargos.toLocaleString('pt-br', {
						style: 'currency',
						currency: 'BRL',
					}) || '',
					descricao: descricao, 
					totalPagoNosJuros: somaValorPagamentoJurosExistentes.toLocaleString('pt-br', {
						style: 'currency',
						currency: 'BRL',
					}) || '',
					totalPagoNaMulta: somaValorPagamentoMultaExistentes.toLocaleString('pt-br', {
						style: 'currency',
						currency: 'BRL',
					}) || '',
					totalPagoNoTitulo: somaValorPagamentoBaixasExistentes.toLocaleString('pt-br', {
						style: 'currency',
						currency: 'BRL',
					}) || '',
					totalPago: somaValorPagamentoBaixasExistentesTotaisNoTitulo.toLocaleString('pt-br', {
						style: 'currency',
						currency: 'BRL',
					}) || '',
				};
		
			});
		}



		get filtrosFormatados(): FiltroDeTitulos {
			return {
				tipoDeCliente: this.filtros.tipoDeCliente?.id || undefined,
				pessoa: this.filtros.pessoa?.id || undefined,
				dataInicioPeriodo: this.filtros.dataInicioPeriodo || undefined,
				dataFimPeriodo: this.filtros.dataFimPeriodo || undefined,
				situacaoDoTitulo: this.filtros.situacaoDoTitulo || undefined,
				formaDePagamento: this.filtros.formaDePagamento || undefined,
				loja: this.filtros.loja || undefined,
				numeroDocumento: this.filtros.numeroDocumento || undefined,
				dataInicioPagamento: this.filtros.dataInicioPagamento || undefined,
				dataFimPagamento: this.filtros.dataFimPagamento || undefined,
				numeroDoCheque: this.filtros.numeroDoCheque || undefined,
				clienteAdquirente: this.filtros.clienteAdquirente || undefined,
				filtroRapido: this.filtroRapidoAtivo || undefined,
				somenteComValorDesatualizado: this.filtros.somenteComValorDesatualizado || undefined,
				somenteComErroDeRecalculo: this.filtros.somenteComErroDeRecalculo || undefined,
			}
		}

		obterFiltrosDeTitulosIniciais(): FormDeFiltroDeTitulos {
			return {
				pessoa: null,
				tipoDeCliente: null,
				dataInicioPeriodo: null,
				dataFimPeriodo: null,
				situacaoDoTitulo: null,
				formaDePagamento: null,
				loja: null,
				numeroDocumento: null,
				dataInicioPagamento: null,
				dataFimPagamento: null,
				fluxo: "Entrada",
				numeroDoCheque: null,
				clienteAdquirente: null,
				somenteComValorDesatualizado: false,
				somenteComErroDeRecalculo: false,
			}
		}

		tituloComValorDesatualizado(item: any): boolean {
			if (!item.dataHoraAtualizacaoValorAtualizado) return false
			if(item.situacao === 'Cancelado') return false
			const fp = item.formaDePagamento
			if (fp !== 'Crediário' && fp !== 'Boleto') return false
			const dataAtual = new Date(item.dataHoraAtualizacaoValorAtualizado)
			const hoje = new Date()
			const dataAtualSoData = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), dataAtual.getDate())
			const hojeSoData = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate())
			return dataAtualSoData < hojeSoData
		}

		classesDaLinha(item: any): string {
			if (!this.temAcessoIrrestrito || item.situacao === 'Pago' ) return ''
			if (item.ultimoErroDeRecalculo) return 'titulo-com-erro-recalculo'
			return this.tituloComValorDesatualizado(item) ? 'titulo-valor-desatualizado' : ''
		}

		async atualizarValorAtualizado(item: any): Promise<void> {
			if (this.titulosAtualizandoIds.includes(item.id)) return
			this.titulosAtualizandoIds.push(item.id)

			try {
				await this.findTituloUseCase.recalcularTitulo(item.id)

				this.aplicarFiltros();

				this.titulosAtualizandoIds = this.titulosAtualizandoIds.filter(id => id !== item.id)
				return AlertModule.setSuccess('Valor Atualizado do Titulo: ' + `${item.numero}` + `${item.serie != null ? '/' + item.serie : ''}` + ` Parcela: ${item.parcela}` + ' Foi concluido com exito!')
			} catch (error) {
				this.titulosAtualizandoIds = this.titulosAtualizandoIds.filter(id => id !== item.id)
				AlertModule.setError(error)
			}
		}

		displayPagamento(formaDePagamento: string) {
			let formaFormatada
			if (formaDePagamento == 'CARTAO') formaFormatada = 'Cartão'
			if (formaDePagamento == 'DINHEIRO') formaFormatada = 'Dinheiro'
			if (formaDePagamento == 'VOUCHER') formaFormatada = 'Voucher'
			if (formaDePagamento == 'OUTROS') formaFormatada = 'Outros'
			if (formaDePagamento == 'TEF CREDITO') formaFormatada = 'TEF Crédito'
			if (formaDePagamento == 'TEF DEBITO') formaFormatada = 'TEF Débito'
			if (formaDePagamento == 'CREDIARIO') formaFormatada = 'Crediário'
			if (formaDePagamento == 'LINK') formaFormatada = 'Link'
			if (formaDePagamento == 'CHEQUE') formaFormatada = 'Cheque'
			if (formaDePagamento == 'BOLETO') formaFormatada = 'Boleto'
			if (formaDePagamento == 'PIX') formaFormatada = 'Pix'
			return formaFormatada
		}

		async buscar(
			paginavel: Pageable,
			parametros: {
			nomeDoCliente?: string
			tipoDeCliente?: string
			loja?: string
			numeroDocumento?: string
			filtroRapido?: string
		},
			cancelToken: CancelToken,
		): Promise<Page<Titulo>> {
			this.buscando = true
			const pagina = await this.findTituloUseCase.find(
				{
					...paginavel,
					...parametros,
					fluxo: 'Entrada',
					token: this.tokenDoUsuario,
				},
				{
					cancelToken,
				},
			)
			this.titulos = pagina.content
			this.buscarTotalizador()
			return pagina
		}

		async buscarTotalizador() {
			try {
				const pagina = await this.findTituloUseCase.findTotalizador({
					...this.filtrosFormatados,
					fluxo: 'Entrada',
					token: this.tokenDoUsuario,
				});

				this.totalizador = pagina;
				this.buscando = false
				return this.totalizador;
			
			}catch (e) {
				AlertModule.setError(e)
				this.buscando = false
			}
		}

		async exportarCsv() {
			try {
				this.filtrosFormatados.fluxo = "Entrada"
				AlertModule.setSuccess('O arquivo está sendo gerado. O processo pode levar alguns minutos.')
				const response: any = await this.findTituloUseCase.exportCsv(this.filtrosFormatados)
				const url = window.URL.createObjectURL(new Blob([response]));
				const link = document.createElement('a')
				link.href = url
				link.setAttribute('download', `titulos.csv`)
				document.body.appendChild(link)
				link.click()
			} catch (e) {
				AlertModule.setError(e)
			} 
		}

		get itens() {
			return this.titulos
		}

		async removerTitulo() {
			if (!this.tituloParaDeletar) return;

			try {
				const tituloId = this.tituloParaDeletar.id;
				if (tituloId) {
					await this.deleteTituloUseCase.execute(tituloId);
					this.titulos = this.titulos.filter(({ id }) => id !== tituloId);
				}
			} catch (error: any) {
				AlertModule.setError(error);
			}
		}

		@Watch('usarTodosOsFiltrados')
		async selecionarTodos() {
			try{
				this.buscando = true
				this.todosForamSelecionados = true
				if (this.usarTodosOsFiltrados) {
					await this.buscarPorTodosOsTitulosNaoPagos()
				} else {
					await this.buscarPorTitulosNaoPagos()
				}
				
				this.titulosSelecionados = this.titulosFormatados.filter(
					(titulo) => titulo.situacao === 'Aberto',
				)
				this.quantidadeItensSelecionados = this.titulosSelecionados.length;
				this.cancelToken = axios.CancelToken.source()
				this.buscar(
					{ page: this.paginacao.page, size: this.paginacao.itemsPerPage },
					this.filtrosFormatados,
					this.cancelToken.token,
				)
			}catch(error){
				AlertModule.setError(error);
				this.buscando = false
			} finally{
				this.buscando = false
			}
		}

		async baixarSelecionados() {
			if (!this.podeBaixarSelecionados) return AlertModule.setError('Perfil não possui permissão para baixar selecionados.')
			const titulosId = this.titulosSelecionados.map(itemDaLista => itemDaLista.id);

			if (!this.titulosSelecionados.length) return;

			const titulosInvalidos = this.titulosSelecionados.filter(
				itemDaLista => itemDaLista.situacao !== 'Aberto',
			);

			if (titulosInvalidos.length) {
				AlertModule.setError('Somente títulos abertos devem ser selecionados');
				return;
			}

			try {
				this.buscando = true;
				this.titulosAlterados = await this.saveTituloUseCase.updateTitulos(
					titulosId,
					'Pago',
				);
			} catch (error) {
				AlertModule.setError(error);
			} finally {
				this.buscando = false;
				this.titulosSelecionados = [];
				AlertModule.setSuccess('Baixa de recebíveis realizada com sucesso!');
			}

			if (this.titulosAlterados?.length) {
				for (let i = 0; i < this.titulos.length; i++) {
					this.titulosAlterados.forEach(tituloAlterado => {
						if (tituloAlterado.id === this.titulos[i].id) {
							this.titulos.splice(i, 1, tituloAlterado);
						}
					});
				}
			}

			this.cancelToken = axios.CancelToken.source();
			const pageable = { page: this.paginacao.page, size: this.paginacao.itemsPerPage, sort: [] };
			const filtros = { ...this.filtrosFormatados };
			
			await this.buscar(pageable, filtros, this.cancelToken.token);
		}

		get temAcessoIrrestrito() {
			return UserLoginStore.permiteRegraDeNegocio('acesso-irrestrito')
		}

		get podeBaixarSelecionados(){
			return UserLoginStore.permiteRegraDeNegocio('pode-baixar-selecionados-contas-a-receber')
		}

		get podeBaixarMultiplas(){
			return UserLoginStore.permiteRegraDeNegocio('pode-baixar-multiplas-contas-a-receber')
		}


}

export interface FormDeFiltroDeTitulos {
	pessoa: null | Usuario
	tipoDeCliente: TipoDeCliente | null
	dataInicioPeriodo: string | null
	dataFimPeriodo: string | null
	situacaoDoTitulo: SituacaoDoTitulo | null
	formaDePagamento: string | null
	loja: string | null
	numeroDocumento: string | null
	dataInicioPagamento: string | null
	dataFimPagamento: string | null
	fluxo: FluxoDoTitulo | null
	numeroDoCheque: string | null
	clienteAdquirente: string | null
	somenteComValorDesatualizado: boolean | null
	somenteComErroDeRecalculo: boolean | null
}
